module.exports = {
  navList: [
    {
      index: '1',
      icon: 'el-icon-data-line',
      name: '数据分析',
      path: '/analysis',
      children: [
        {
          index: '1-1',
          name: '品牌看板',
          authId: '01-01',
          path: '/analysis/overview',
          pathGroup: [
            '/analysis/overview',
            '/analysis/content',
            '/analysis/comment',
            '/analysis/guruImage'
          ]
        }, {
          index: '1-2',
          name: '竞品对比',
          authId: '01-02',
          path: '/analysis/competCompare',
          pathGroup: [
            '/analysis/competCompare'
          ]
        }
      ]
    }, {
      index: '2',
      icon: 'el-icon-menu',
      name: '数据管理',
      path: '/dataManage',
      children: [
        {
          index: '2-1',
          name: '笔记数据',
          path: '/contentHome',
          authId: '02-01',
          pathGroup: [
            '/dataManage/list',
            '/dataManage/detail',
            '/dataManage/contentImport'
          ]
        },
        {
          index: '2-3',
          name: '指数数据',
          path: '/exponentialHome',
          authId: '02-02',
          pathGroup: [
            '/dataManage/exponentialList',
            '/dataManage/exponentialDetail',
            '/dataManage/exponentialImport'
          ]
        },
        {
          index: '2-5',
          name: '笔记数据(ZQ)',
          path: '/noteZQHome',
          authId: '02-03',
          pathGroup: [
            '/dataManage/noteZQList',
            '/dataManage/noteZQDetail',
            '/dataManage/noteZQImport',
            '/dataManage/noteMolonChatImport'
          ]
        }
      ]
    }, {
      index: '4',
      icon: 'el-icon-s-grid',
      name: '项目管理',
      path: '',
      children: [
        {
          index: '4-1',
          authId: '04-01',
          name: '项目列表',
          path: '/iframe?iframeSrc=' + process.env.VUE_APP_IFRAME_MANAGE_URL,
          pathGroup: []
        }, {
          index: '4-2',
          authId: '04-02',
          name: '数据管理',
          path: '/manageTableIframe?iframeSrc=' + process.env.VUE_APP_IFRAME_MANAGE_Table_URL,
          pathGroup: []
        }
      ]
    }, {
      index: '3',
      icon: 'el-icon-setting',
      name: '后台管理',
      path: '/backManage',
      children: [
        {
          index: '3-1',
          name: '用户管理',
          path: '/back/userManage',
          authId: '03-01',
          pathGroup: [
            '/back/userManage',
            '/userManage/detail'
          ]
        },
        {
          index: '3-2',
          name: '权限管理',
          path: '/back/userPermission',
          authId: '03-02',
          pathGroup: [
            '/back/userPermission',
            '/userPermission/detail'
          ]
        }
      ]
    }
  ]
}
